import { Box } from 'components/ui';
import { colors } from 'style/config';

const styles = {
    root: `
        border-bottom: 1px solid ${colors.lightGray};
        padding-top: 16px;
        .LoadingLineAnimation {
            margin-bottom: 16px;
        }
        .horizontal {
            display: flex;
            div:last-child {
                margin-left: auto;
            }            
        }
    `,
    loader: `
        height: 8px;
        border-radius: 4px;
        background: linear-gradient(225deg, ${colors.midGray} 0%, ${colors.lightGray} 100%);        
        background-size: 200% 100%;
        animation: loadingAnimation 1.2s ease infinite;
        
        @keyframes loadingAnimation {
            0% {
                background-position: 100% 50%;
            }
            100% {
                background-position: 0% 50%;
            }
        }   
    `
};

const LoadingLineAnimation = ({ width = 48 }) => {
    return <Box width={width} css={styles.loader} className='LoadingLineAnimation'/>;
};

const LoadingActivityCard = () => {
    return <Box css={styles.root}>
        <div className='horizontal'>
            <LoadingLineAnimation width={142}/>
            <LoadingLineAnimation/>
        </div>
        <LoadingLineAnimation width={98}/>
    </Box>;
};

export default LoadingActivityCard;
